module.exports = __webpack_public_path__ + "static/media/page-not-found.dfe722f8.png";